export const AIR_PAYOUT_AMOUNT = 100;
export const AIR_LUGGAGE_AMOUNT = 100;
export const SMART_UPGRADE_FIRST_YEAR_SAVE_AMOUNT = 50;

export const NO_FEE_UP_TO_COMPENSATION_AMOUNT = 600;
export const HOURS_APPLY_THRESHOLD = 48;
